import { WheelOfFortune } from '@/components/wheel/WheelOfFortune';
import { MobilePageHeader } from '@/components/ui/mobile-page-header';
import { Sparkles } from 'lucide-react';

const WheelPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-black via-black to-gray-900 pb-24 md:pb-6">
      <MobilePageHeader 
        title="Roleta da Sorte" 
        icon={<Sparkles className="w-5 h-5 text-luxury-pinkBright" />}
        backPath="/main/feed"
      />

      <div className="pt-16 md:pt-8 px-4">
        <div className="max-w-md mx-auto">
          {/* Header - Desktop only (mobile has MobilePageHeader) */}
          <div className="hidden md:block text-center mb-6">
            <h1 className="text-2xl font-bold text-white mb-2">
              🎰 Roleta da Sorte
            </h1>
            <p className="text-white/60 text-sm">
              Gire e ganhe gemas, boosts e até um dia VIP!
            </p>
          </div>

          {/* Wheel Component */}
          <div className="bg-white/5 border border-white/10 rounded-2xl p-6 backdrop-blur-sm">
            <WheelOfFortune />
          </div>

          {/* Info */}
          <div className="mt-6 space-y-3">
            <div className="bg-white/5 border border-white/10 rounded-xl p-4">
              <h3 className="text-sm font-semibold text-white mb-2 flex items-center gap-2">
                <span>🎁</span> Prêmios disponíveis
              </h3>
              <div className="grid grid-cols-2 gap-2 text-xs text-white/60">
                <div className="flex items-center gap-2">
                  <span>💎</span> 1-3 Gemas
                </div>
                <div className="flex items-center gap-2">
                  <span>🚀</span> 1-3 Boosts
                </div>
                <div className="flex items-center gap-2">
                  <span>👑</span> 1 Dia VIP
                </div>
                <div className="flex items-center gap-2">
                  <span>🔄</span> Tente novamente
                </div>
              </div>
            </div>

            <div className="bg-white/5 border border-white/10 rounded-xl p-4">
              <h3 className="text-sm font-semibold text-white mb-2 flex items-center gap-2">
                <span>ℹ️</span> Como funciona
              </h3>
              <ul className="text-xs text-white/60 space-y-1">
                <li>• Usuários Intro: 1 giro grátis por dia</li>
                <li>• Usuários Inspire: 2 giros grátis por dia</li>
                <li>• Usuários Infinity: 3 giros grátis por dia</li>
                <li>• Use 1 gema para giros extras</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WheelPage;
